import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { useQuery } from '@tanstack/react-query';

/**
 * Documento da apólice RD Equipamentos (0171) para VISUALIZAÇÃO na tela.
 *
 * É o mesmo binário do botão "Baixar PDF Apólice" (`useOwnBackendPolicyPdf`):
 * `GET /rd-equipamentos/quotes/:id/policy-pdf` no BFF, que repassa ao motor
 * (`/api/v1/rd/proposals/:id/pdf`), onde a Folheteria renderiza o documento
 * a partir do modelo publicado. Antes desta rota a tela montava uma réplica
 * HTML da apólice no front — o mesmo segurado via um documento na tela e
 * recebia outro ao baixar.
 *
 * `gcTime: 0` é deliberado: o valor em cache é um `Blob` (o PDF inteiro na
 * memória da aba). Mantê-lo depois que a tela sai acumularia um documento
 * por apólice visitada.
 */
export function useRdPolicyDocument(proposalId: string | undefined) {
  return useQuery({
    queryKey: ['rd-policy-document', proposalId],
    queryFn: async () => {
      if (!proposalId) {
        throw new Error('ProposalId é obrigatório');
      }

      return rdEquipamentosService.policyPdf(proposalId);
    },
    enabled: !!proposalId,
    // O motivo real da falha vem no corpo da resposta (ex.: "A apólice só
    // fica disponível depois da emissão"). Repetir a chamada só atrasa a
    // mensagem — nenhuma dessas causas se resolve sozinha.
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
}
